import React from 'react'
import styles from './styles.module.scss'
import Merchant from '@/src/interfaces/merchant/merchant'
import MerchantLogo from '../../logo/merchant-logo'
import MerchantCover from '../../cover/merchant-cover'
import BasicInfos from '../../basic-infos/basic-infos'

interface Props {
    merchant: Merchant.Response
}

export default function ProfileHeader({ merchant }: Props) {
    return (
        <div className={styles.container}>
            <div className={styles.imagesArea}>
                <MerchantCover className={styles.banner} />
                <MerchantLogo className={styles.logo} />
            </div>
            <div id="merchant-title" className={styles.merchantNameArea}>
                <h2 className={`font-xlg ${styles.merchantName}`}>{merchant.name}</h2>
            </div>
            <BasicInfos isProfile />
            {merchant?.description ? <p className={`${styles.description} font-md`}>{merchant?.description}</p> : <></>}
        </div>
    )
}
